import { HorizontalLayout, VerticalLayout } from "./layout";

export const DropdownRows = ({ open, rows, setChild, toggleOpen, setParent, defaultCountry}) => {
  const filteredRows = rows.filter( r => r.code !== defaultCountry?.code );
  const displayRows = defaultCountry?.name ? [defaultCountry, ...filteredRows] : rows;
    
  return (
    <VerticalLayout
      className={`dropdown-content country-dropdown ${open ? "active" : ""}`}
      style={{ minHeight: open ? "10rem" : "0px", opacity: open ? 1 : 0 }}
    >
      {displayRows.map((row) => {
        const isProvince = !!row.flag;

        return (
          <HorizontalLayout 
          key={row.code || row.name} 
          onClick={() => { setChild({ code: row.code || null, land: isProvince ? null : row.name, visible: false, flag: row.flag || null }); toggleOpen(); setParent({ code: row.code || null, land: isProvince ? null : row.name,  province: isProvince ? row.name : null });}}
          className="country-dropdown-item"
          >
            <img
              src={ row.flag ? row.flag : `https://flagcdn.com/w20/${row.code}.png`}
              width="16"
              height="12"
            />
            <span>{row.name}</span>
          </HorizontalLayout>
        );
      })}
    </VerticalLayout>
  );
};
